import { PlanT } from '@segurodeceso/core/domain/plans';

import { BaseDataLayer, DataLayerPlanType, PLAN_CODE_MAP, SALE_WITH_AGENT_MAP } from './base';

type OperationType = 'Sumar' | 'Restar';

const baseEventParams = {
  page: '/deceso/cotizador',
  page_title: 'Deceso - Cotizador',
  product: 'Seguro Deceso',
  view_type: 'web',
};

const viewDataLayer = {
  ...baseEventParams,
  action_type: 'Pageview',
};

const sumRestDataLayer = (operation: OperationType) => ({
  ...baseEventParams,
  action_type: 'click',
  action: `Click - ${operation} Familiar`,
});

const planDetailDataLayer = (plan: DataLayerPlanType) => ({
  ...baseEventParams,
  action_type: 'click',
  action: 'Click - Ver mas detalles',
  product_type: plan,
});

const planClickDataLayer = (plan: DataLayerPlanType) => ({
  ...baseEventParams,
  action_type: 'click',
  action: 'Click - Seleccionar Card',
  product_type: plan,
});

const questionClickDataLayer = (question: string) => ({
  ...baseEventParams,
  action_type: 'click',
  action: `Click - ${question}`,
});

const modalAcceptDataLayer = (modalName: string) => ({
  ...baseEventParams,
  action_type: 'click',
  action: `Click - Aceptar ${modalName}`,
});

export const quoterPageView = (withAgent: boolean) =>
  BaseDataLayer({
    eventParams: { ...viewDataLayer, venta_asistida: SALE_WITH_AGENT_MAP[withAgent.toString()] },
  });

export const quoterSumRestClick = (operation: OperationType) =>
  BaseDataLayer({ eventParams: sumRestDataLayer(operation) });

export const quoterPlanDetailClick = (plan: PlanT) =>
  BaseDataLayer({ eventParams: planDetailDataLayer(PLAN_CODE_MAP[plan.planCode]) });

export const quoterPlanClick = (plan: PlanT) =>
  BaseDataLayer({ eventParams: planClickDataLayer(PLAN_CODE_MAP[plan.planCode]) });

export const quoterQuestionClick = (question: string) =>
  BaseDataLayer({ eventParams: questionClickDataLayer(question) });

export const quoterModalAcceptClick = (modalName: string) =>
  BaseDataLayer({ eventParams: modalAcceptDataLayer(modalName) });
